const useAdminPermission = () => {
    return{
        
    }
}
export default useAdminPermission;